import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type TrainingInvitationProps = BaseNotificationItemProps & {
  type: 'training_invitation'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function TrainingInvitation({ program, ...props }: TrainingInvitationProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Training Invitation`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You've been invited to begin training for ${program.displayName}. Get started to become eligible for work on this program.`}</p>
      }
    />
  )
}
